import {Component, inject, OnInit} from '@angular/core';
import initHelpHero from 'helphero';
import { Profile } from '@shared/models/user';
import { ConfigService } from '@services/config/config.service';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { SharedModule } from '@shared/shared.module';
import { RouterOutlet } from '@angular/router';


@Component({
    standalone: true,
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [SharedModule, RouterOutlet],
})
export class AppComponent implements OnInit {

    private configService: ConfigService;
    private keycloak: Keycloak;

    constructor(
    ) {
        this.keycloak = inject(Keycloak);
        this.configService = inject(ConfigService);
    }

    ngOnInit() {
        if (typeof window !== 'undefined' && this.configService.config?.helpheroAppId) {
            const helpHero = initHelpHero(this.configService.config.helpheroAppId);
            this.keycloak.loadUserProfile()
                .then((profile: KeycloakProfile) => profile as Profile)
                .then((profile: KeycloakProfile) => helpHero.identify(profile.id ? profile.id : 0, { username: profile.username }));
        }
    }
}
